import { useEffect, useRef, useState } from "react";
import { fetchAdmissionsPoliciesBySchoolId } from "./admissions.api";
import { UI_MSG } from "../../config/uiMessages";

/**
 * Loads admissions_policies for exam and/or allocation drawer sections (independent of catchment).
 */
export function useAdmissionsPolicies(schoolId, enabled) {
  const cacheRef = useRef({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [, setVersion] = useState(0);

  const shouldFetch = schoolId && enabled;
  const cached = cacheRef.current[schoolId];
  const policies = cached?.policies ?? null;
  const allocationHistory = cached?.allocationHistory ?? null;

  useEffect(() => {
    if (!shouldFetch) {
      setError(null);
      return;
    }

    if (cacheRef.current[schoolId]) {
      setError(null);
      return;
    }

    let cancelled = false;
    setLoading(true);
    setError(null);

    fetchAdmissionsPoliciesBySchoolId(schoolId)
      .then((data) => {
        if (!cancelled) {
          cacheRef.current = {
            ...cacheRef.current,
            [schoolId]: {
              policies: data.policies ?? [],
              allocationHistory: data.allocationHistory ?? [],
            },
          };
          setVersion((v) => v + 1);
          setError(null);
        }
      })
      .catch((err) => {
        if (!cancelled) {
          setError(UI_MSG.ADMISSIONS_LOAD_FAILED);
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [schoolId, enabled, shouldFetch]);

  return { policies, allocationHistory, loading, error };
}
